import React from 'react';
import styles from './CookieAgreement.module.scss';
import Button from "../style-guide/button/Button";
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {emptyFn} from "presentation/common/helpers/utils";
import CloseIcon from "../style-guide/icons/Close.icon";

export const CookieAgreement = (props) => {
  const {className, onAgreementCookie, onClose} = props;

  return (
    <div className={clsx(styles.container, className , "border-t border-l border-r border-primary relative")}>
       <button className={styles.closeBtn} aria-label="Close" onClick={onClose}>
         <CloseIcon className="inline-icon" stroke="black"/>
       </button>
       <p className={clsx(styles.title, 'text-primary')}>tu privacidad es importante para nosotros</p>
       <div className={styles.content}>
         <div>
           Nosotros y nuestros socios utilizamos tecnologías como las cookies y procesamos datos personales para
           personalizar los anuncios y el contenido según sus intereses. Haga clic en "Acepto" para autorizar el uso de
           esta tecnología y el procesamiento de sus datos personales para estos fines.
         </div>
         <Button label="Acepto" onClick={onAgreementCookie} className={styles.btn} />
       </div>
    </div>
  );
};

CookieAgreement.propTypes = {
  className: PropTypes.string,
  onAgreementCookie: PropTypes.func,
  onClose: PropTypes.func
}

CookieAgreement.defaultProps = {
  onAgreementCookie: emptyFn(),
  onClose: emptyFn(),
}

export default CookieAgreement;
